<template>
    <div class="animated fade-in">

        <c-data-table
                class="my-4"
                :items="items"
                :fields="fields"
                :table-filter="true"
                :items-per-page="params.limit"
                items-per-page-select
                hover
                sorter
                :pagination="false"
                :sorterValue="params.sort"
                :tableFilterValue="params.filter"
                :loading="loading"
                @pagination-change="pageChange"
                @update:sorter-value="sortChange"
                @update:table-filter-value="filterChange">

            <template #contact_name="{item}">
                <td>{{ item.contact.full_name }}</td>
            </template>
            <template #contact_email="{item}">
                <td>{{ item.contact.email }}</td>
            </template>
            <template #invite="{item}">
                <td>
                    {{inviting[item.id]}}
                    <b-button v-if="inviting[item.id]" size="sm" class="py-0" block><i class="fal fa-spin fa-spinner"></i></b-button>
                    <b-button v-else-if="item.user_id || invited[item.id]" size="sm" disabled block class="py-0">Sent</b-button>
                    <b-button v-else-if="!item.user_id && item.contact.email" size="sm" class="btn-sf py-0" block @click="sendInvite(item)"><i class="fal fa-paper-plane"></i></b-button>
                </td>
            </template>

        </c-data-table>

        <c-pagination
                :active-page="params.page"
                :pages="Math.ceil(+(total/params.limit))"
                @update:activePage="updatePageNum"
        ></c-pagination>

    </div>
</template>

<script>
  import ToastNotifications from "../../components/shared/mixins/ToastNotifications";
  import Employee from "../../models/Employee";
  import Contact from "../../models/Contact";
  import User from "../../models/User";

  export default {
    name: 'EmployeeTable',
    components: {},
    mixins: [ToastNotifications],
    data () {
      return {
        loading: true,
        employees: [],
        items: [],
        fields: [
          { key: 'contact_name', label: 'Employee' },
          { key: 'contact_email', label: 'Email' },
          { key: 'invite', label: 'Invite' },
        ],
        total: null,
        params: {
          page: 1,
          limit: 20,
          sort: { column: 'id', asc : false},
          filter: null
        },
        inviting: {},
        invited: {}
      }
    },
    methods: {
      pageChange: function(val) {
        this.params.limit = val;
        this.fetch();
      },
      sortChange: function(val) {
        this.params.sort.column = val.column;
        this.params.sort.asc = val.asc;
        this.fetch();
      },
      filterChange: function(val) {
        this.params.filter = (val ? (val !== '' ? val : null) : null);
        this.fetch();
      },
      updatePageNum: function(val) {
        this.params.page = Math.ceil(val);
        this.fetch();
      },
      fetch: function() {
        this.loading = true;
        let params = JSON.parse(JSON.stringify(this.params));
        if(params && params.filter) {
          params.search = params.filter;
        }
        return Employee.api().fetch(params).then((results) => {
          this.total = results.response.data.data.pagination.total;
          let employees = results.entities.employees;
          let contacts = [];
          let users = [];
          employees.forEach((employee) => {
            contacts.push(employee.contact_id);
            users.push(employee.user_id);
          });
          return Promise.all([
            Contact.api().fetch({limit: 9999, id: contacts.join('|')}),
            User.api().fetch({limit: 9999, id: users.join('|')}),
          ]).then(() => {
            let temp = [];
            employees.forEach((employee) => {
              temp.push(Employee.query().where('id', employee.id).with(['contact','user']).first());
            });
            this.employees = temp;
            this.items = this.employees;
            this.loading = false;
          });
        });
      },
      sendInvite(model) {
        this.inviting[model.id] = true;
        Employee.api().invite(model.id).then(() => {
          delete this.inviting[model.id];
          this.invited[model.id] = model;
          this.quickSuccessToast('Employee Invited', 'The invitation was sent successfully.');
        },() => {
          this.quickSuccessToast('Employee Invite Failed', 'The invitation could not be set.');
        });
      },
    },
    created() {
      this.fetch();
    }
  }
</script>
